interface AlertBar {
  /** Main element for the alert bar. */
  root: Element;

  /** Has the user already closed this alert bar? */
  dismissed: boolean;

  /** Unique identifier for the alert bar. */
  uid: string | null;

  /** Any elements which will dismiss the alert. */
  dismissTargets: Element[];
}

const alertBars = (): AlertBar[] =>
  [
    ...(<NodeListOf<HTMLElement>>document.querySelectorAll(".js-alert-bar")),
  ].map((alertBar): AlertBar => {
    return {
      root: alertBar,
      dismissed:
        localStorage.getItem(`ALERT_BAR_${alertBar.dataset.uid}`) === "seen",
      uid: alertBar.dataset.uid || null,
      dismissTargets: Array.from(
        alertBar.querySelectorAll(".js-alert-bar-close, a")
      ),
    };
  });

const showAlertBar = (alertBar: AlertBar) =>
  alertBar.root.classList.remove("hidden");

const hideAlertBar = (alertBar: AlertBar) => {
  localStorage.setItem(`ALERT_BAR_${alertBar.uid}`, "seen");
  alertBar.root.classList.add("hidden");
};

const shouldAlertBarAppear = (alertBar: AlertBar): boolean =>
  alertBar.dismissed === false;

export default alertBars().map((alertBar) => {
  if (shouldAlertBarAppear(alertBar)) {
    showAlertBar(alertBar);
  }

  alertBar.dismissTargets.forEach((target) => {
    target.addEventListener("click", () => {
      hideAlertBar(alertBar);
    });
  });

  return alertBar;
});
